import { cn } from "@/lib/utils";
import * as LucideIcons from "lucide-react";
import React from "react";
import type { FilterSchema } from "./types";

/** The object tile (white glyph on the object colour), as served by the filter schema. */
export function FilterSchemaTile({ schema, size = "sm" }: { schema: Pick<FilterSchema, "icon" | "color">; size?: "sm" | "md" }) {
    const Icon = ((LucideIcons as unknown as Record<string, React.ComponentType<{ className?: string }>>)[schema.icon || "Circle"] ?? LucideIcons.Circle) as React.ComponentType<{
        className?: string;
    }>;
    return (
        <span
            className={cn("inline-flex flex-shrink-0 items-center justify-center rounded-sm bg-gray-500", size === "sm" ? "h-5 w-5" : "h-6 w-6")}
            style={schema.color ? { backgroundColor: schema.color } : undefined}
        >
            <Icon className={cn("text-white", size === "sm" ? "h-3 w-3" : "h-4 w-4")} />
        </span>
    );
}
